import React from 'react';

import { FormattedMessage } from 'react-intl';

import { LinkButton } from '@atlaskit/button-next/new';
import Heading from '@atlaskit/heading';
import { Stack, Text, xcss, Inline, Box } from '@atlaskit/primitives';

import { CloudsIcon } from './assets/clouds-icon';
import { messages } from './messages';

interface EmptySummaryProps {
	orgId: string;
}

const containerStyles = xcss({
	width: '100%',
	borderRadius: 'border.radius.200',
	borderWidth: 'border.width',
	borderStyle: 'solid',
	borderColor: 'color.border.disabled',
	backgroundColor: 'elevation.surface.sunken',
	padding: 'space.200',
});

const PaperAirplaneStyles = xcss({
	display: 'flex',
	width: '115px',
	height: '115px',
	justifyContent: 'center',
	alignItems: 'center',
});

export const EmptySummary: React.FC<EmptySummaryProps> = ({ orgId }) => {
	const assessmentsUrl =
		process.env['NODE_ENV'] === 'production'
			? `https://admin.atlassian.com/o/${orgId}/product-insights/products`
			: `https://admin.stg.atlassian.com/o/${orgId}/product-insights/products`;
	return (
		<Inline xcss={containerStyles} space="space.400">
			<Box xcss={PaperAirplaneStyles}>
				<CloudsIcon />
			</Box>
			<Stack space="space.200">
				<Heading size="small">
					<FormattedMessage {...messages.emptyAssessmentTitle} />
				</Heading>
				<Text>
					<FormattedMessage {...messages.emptyAssessmentDescription} />
				</Text>
				<Inline space="space.100">
					<LinkButton href={assessmentsUrl} target="_blank">
						<FormattedMessage {...messages.startAssessmentButton} />
					</LinkButton>
					<LinkButton
						appearance="subtle"
						href="https://support.atlassian.com/portfolio-insights/docs/what-is-portfolio-insights/"
						target="_blank"
					>
						<FormattedMessage {...messages.learnMoreLink} />
					</LinkButton>
				</Inline>
			</Stack>
		</Inline>
	);
};
